<div class="container">
    <div class="dialog-header">
        <div class="dialog-header-text">
            <h4 class="dialog-title" data-test="titulo-modal-tabela-dashboard">{{ data.title }}</h4>
            <span class="dialog-subtitle" data-test="contagem-modal-tabela-dashboard">{{ recordsCountLabel }}</span>
        </div>
        <button mat-icon-button matDialogClose="close" class="btn-close"
            [attr.aria-label]="closeButtonAriaLabel"
            data-test="btn-fechar-modal-tabela-dashboard">
            <i class="material-icons">close</i>
        </button>
    </div>

    <div class="table-scroll" #tableScroll *ngIf="data.rows.length; else emptyState">
        <div class="continuation-notice" *ngIf="data.continuationNoticeLabel" data-test="aviso-continuacao-modal-tabela-dashboard">
            <i class="material-icons">subdirectory_arrow_right</i>
            <span>{{ data.continuationNoticeLabel }}</span>
        </div>
        <table class="demo-table" data-test="tabela-modal-dashboard">
            <thead>
                <tr>
                    <th *ngFor="let header of data.headers; let i = index" [class.align-right]="columnAlignments[i] === 'right'" [class.align-center]="columnAlignments[i] === 'center'">{{ header }}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of data.rows; let rowIndex = index; trackBy: trackByIndex">
                    <tr class="table-group-row" *ngIf="groupHeaderBeforeRow[rowIndex]">
                        <td [attr.colspan]="data.headers.length">{{ data.rowGroupLabels?.[rowIndex] }}</td>
                    </tr>
                    <tr data-test="linha-modal-dashboard" [class.table-subgroup-row]="subGroupBoundaryBeforeRow[rowIndex]" [class.table-continuation-row]="continuationRow[rowIndex]">
                        <td *ngFor="let cell of row; let i = index; trackBy: trackByIndex" [attr.data-test]="'celula-modal-dashboard-' + i" [class.align-right]="columnAlignments[i] === 'right'" [class.align-center]="columnAlignments[i] === 'center'">{{ cell }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <mat-paginator *ngIf="showPagination && data.pagination as pagination" data-test="paginador-modal-tabela-dashboard"
            [length]="pagination.totalCount"
            [pageSize]="pagination.pageSize"
            [pageIndex]="paginationPageIndex"
            [pageSizeOptions]="[pagination.pageSize]"
            [hidePageSize]="true"
            (page)="onPageEvent($event)">
        </mat-paginator>
    </div>

    <ng-template #emptyState>
        <div class="empty-state" data-test="estado-vazio-modal-tabela-dashboard">
            <i class="material-icons">inbox</i>
            <span>{{ noRecordsFoundLabel }}</span>
        </div>
    </ng-template>
</div>
